import { ISummarySettings } from "./getSettings";
import { PostRequest } from "./http/BaseRequest";
import { clearCache } from "@utils/localCache";
import { settingsCacheKey } from "@utils/hooks/useCurrentUser";
import { BaseResponse, RecordResponse } from "./http/responses/BaseResponse";

export interface AddPoolParams extends ISummarySettings {
  edit?: boolean;
}

export interface IAddPoolResponse extends RecordResponse<number> {
}

export class AddAdminPoolSettings extends PostRequest {
  constructor(params: AddPoolParams) {
    clearCache(settingsCacheKey);
    super("/admin/miner/settings/add", params);
  }
}

export class AddUserPoolSettings extends PostRequest {
  constructor(params: AddPoolParams) {
    clearCache(settingsCacheKey);
    super("/user/miner/settings/add", params);
  }
}
